/**
 * Hoteltip button link functionality
 *
 * Finds all hoteltip blocks and sets the button href
 * to match any link found within the hoteltip block
 */
export default {
  init() {
    const hoteltips = document.querySelectorAll('.hoteltip');

    hoteltips.forEach(hoteltip => {
      // Find any link within the hoteltip block (excluding the button itself)
      const link = hoteltip.querySelector('a:not(.wp-block-button__link)');

      // Find the button within this hoteltip
      const button = hoteltip.querySelector('.wp-block-button__link');

      // If both link and button exist, set button href to link's href
      if (link && button && link.href) {
        button.href = link.href;
      }
    });
  }
};